import { Stack, Typography } from '@mui/material';
import { useListMainItemsQuery } from 'api/ml-service/ml-service';
import ClientPaginationDataGrid from 'components/client-pagination-data-grid/client-pagination-data-grid.component';
import { useUtilityDrawer } from 'components/drawers/utility-drawer/utility-drawer.hooks';
import { useTranslation } from 'react-i18next';
import ItemAnalysisDrawer from '../../../../components/drawers/item-analysis-drawer/item-analysis-drawer.component';
import IncQuickFilterToolbar from 'components/inc-quick-filter-toolbar/inc-quick-filter-toolbar.component';

const ItemAnalysis = () => {
  const { t } = useTranslation();
  const { data, isLoading } = useListMainItemsQuery(null);

  const columns = [
    {
      field: 'itemName',
      headerName: t('page.menus.recommendations.dataGrid.columns.itemName'),
      flex: 1,
      hideable: false,
    },
  ];

  const { open, close, drawerData, toggleWithData } = useUtilityDrawer<{
    itemName: string;
  }>();

  return (
    <Stack p={2} mt={2}>
      <Typography variant="subtitle2">
        {t('page.menus.recommendations.itemAnalysis.subtitle')}
      </Typography>
      <ClientPaginationDataGrid
        columns={columns}
        rows={data?.mainItemNames ?? []}
        slots={{ toolbar: IncQuickFilterToolbar }}
        onRowClick={params => {
          toggleWithData(params.row);
        }}
        isLoading={isLoading}
      />
      <ItemAnalysisDrawer open={open} close={close} drawerData={drawerData} />
    </Stack>
  );
};

export default ItemAnalysis;
